import { useState, useEffect } from "react";
import { showToast } from "../../../../components/common/notification/Notification";
import axios from "axios";
import { useSelector } from "react-redux";

export default function useSubscriptionPlans() {
  const loggedInUser = useSelector((state) => state.auth.user);
  const token = loggedInUser?.refreshToken;
  const baseUrl = process.env.REACT_APP_BASE_URL;
  // const subscriptionPlans = Api({ url: "api/subscription/plan/list" });

  const [plans, setPlans] = useState([]); 
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [expandedPlan, setExpandedPlan] = useState(null);
  const [loading, setLoading] = useState(false);

  const fetchPlans = async () => {
    try {
      const { data } = await axios.post(
        `${baseUrl}/api/subscription/plan/list/paid/by/service`,
        // `${baseUrl}/api/subscription/plan/list`,
        {
          "order_by": loggedInUser.user.first_name + " " + loggedInUser.user.last_name,
          "all_service_id": loggedInUser.user.service_id,
          "pageNumber": 1,
          "pageSize": 100
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      // console.log(data);
      if (data.statusType === "SUCCESS") {
        const updatedPlans = data.subscriptionPlans.map((plan) => {
          const isFree =
            plan.is_free_plan ||
            plan.freePLan ||
            plan.price_paise === 0;

          // Convert paise → rupees
          const price = plan.price_paise / 100;
 
          return {
            ...plan,
            duration_in_days: plan.duration_days,
            price: price,
            is_free: isFree,
          };
        });

        setPlans(updatedPlans);

        const firstPaidPlan = updatedPlans.find((p) => !p.is_free);
        setSelectedPlan(firstPaidPlan?.id || updatedPlans[0]?.id);
      }
    } catch (err) {
      showToast("Unable to fetch subscription plans", { type: "error" });
    }
  };

  useEffect(() => {
    fetchPlans();
  }, []);

  return {
    plans,
    selectedPlan,
    setSelectedPlan,
    expandedPlan,
    setExpandedPlan,
    loading
  };
}
